// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"67":"6856f5c4","91":"9621b0eb","628":"d8257ecc","912":"1977ee35","934":"4361b97f","960":"a38ae8af"}[chunkId] + ".js";
};